<template>
  <div>
    <!-- <toolbar-core /> -->
    <dashboard-new :level-user-percentage="levelUserPercentage.toFixed(1)">
      <template v-slot:header>
        <toolbar-core />
      </template>
      <template v-slot:body>
        <div
          class="ml-10 classContainerBodySlot"
          style="width: calc(100vw - 630px); min-height: calc(100vh - 190px);"
        >
          <h1 class="tittleMyProfile2">
            Favoritos
          </h1>
          <p class="titleMyProfile">
            Panel / Favoritos
          </p>
          <div class="fisrtContainer">
            <span class="fisrtContainer_title">Módulos</span>
            <div class="fisrtContainer_fisrtContainer">
              <v-select
                v-if="!loading_module"
                :items="modules"
                item-value="id"
                item-text="name"
                v-model="moduleId"
                outlined
              ></v-select>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                outlined
                rounded
                label="Buscar"
              ></v-text-field>
            </div>
            <button class="btnSearch">Buscar</button>
          </div>

          <div class="containerTabs">
            <v-tabs v-model="tab">
              <v-tab>
                <span class="capitalize">Básico</span> ({{ basic.length }})
              </v-tab>

              <v-tab>
                <span class="capitalize">Intermedio</span> ({{
                  intermediate.length
                }})
              </v-tab>

              <v-tab>
                <span class="capitalize">Avanzado</span> ({{ advanced.length }})
              </v-tab>
            </v-tabs>
            <div v-for="(item, index) in content_level" :key="index">
              <card-list-v2
                :hidden-fav="true"
                :data="item"
                :icon="switchIcon(item)"
              ></card-list-v2>
            </div>
          </div>
        </div>
      </template>
    </dashboard-new>
  </div>
</template>

<script>
import moment from "moment";
import Notification from "../Utils/notification";
import CardList from "./Components/CardList";
import ToolbarCore from "../core/Toolbar";
import Dashboard from "../Dashboard.vue";
import CardListV2 from "../Profile/Components/CardListV2.vue";
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    "card-list-component": CardList,
    "toolbar-core": ToolbarCore,
    "dashboard-new": Dashboard,
    "card-list-v2": CardListV2,
  },

  data() {
    return {
      itemsPerPageArray: [4, 8, 12],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 4,
      sortBy: "name",
      tab: 0,
      levelUserPercentage: 0,
      content_level_data: [],
      loadingContentData: false,
      loading_module: false,
      advanced: [],
      intermediate: [],
      basic: [],
      modules: [],
      module_id: "",
      levels: [],
      level_id: "",
      content_level: [],
      authUser: {},
    };
  },

  created() {
    this.HandlerGetAuthUser();
    this.HandlerGetLevelPercentage();
  },

  filters: {
    date(val) {
      return moment(val)
        .locale("es")
        .calendar();
    },
  },

  watch: {
    module_id(module_id) {
      this.HandlerListLevels(module_id);
      this.HandlerListContent(module_id);
    },

    tab(val) {
      let level;
      switch (val) {
        case 0:
          level = this.basic;
          break;
        case 1:
          level = this.intermediate;
          break;
        case 2:
          level = this.advanced;
          break;
        default:
          level = this.basic;
          break;
      }
      this.content_level_data = level;
      return level;
    },
  },

  computed: {
    moduleId: {
      get() {
        console.log("this.authUser.module_id", this.authUser.module_id);
        return this.authUser.module_id;
      },
      set(value) {
        this.module_id = value;
      },
    },
    levelId: {
      get() {
        const level_id = this.levels.find(
          (val) => val == this.authUser.level.toLowerCase()
        );
        return level_id;
      },
      set(value) {
        this.level_id = value;
      },
    },
  },

  methods: {


    switchIcon(data) {
      const notNull = data.file_type ?? "audio";
      const dictionary = {
        imagen: "mdi-file-image-outline",
        documento: "mdi-file-document-multiple-outline",
        audio: "mdi-play",
        cuestionario: "mdi-file-document-edit-outline",
        test_content: "mdi-book-check-outline",
        canva: "mdi-search-web",
      };
      // console.log("switch", data, dictionary);
      return dictionary[notNull] ?? "";
    },
    HandlerRouter() {
      this.$router.go(-1);
    },

    async HandlerGetLevelPercentage() {
      try {
        const response1 = await this.$store.dispatch("auth/ME");
        const module_id = response1.data.data.module_id;
        const level = response1.data.data.level;

        const request = { module_id, level };
        const response = await this.$store.dispatch(
          "profile/LEVEL_PERCENTAGE",
          request
        );
        this.levelUserPercentage = response.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        } else {
          this.$snotify.error(error.response.data.message, "Error!");
        }
      }
    },

    async HandlerGetAuthUser() {
      try {
        this.loading_module = true;
        const response = await this.$store.dispatch("auth/ME");
        const module_id = response.data.data.module_id;
        this.modules = [response.data.data.modules];
        const level = response.data.data.level;
        this.module_id = module_id;
        this.level_id = level;
        this.authUser = response.data.data;
        this.HandlerListContent(module_id, level);
        this.HandlerListLevels(module_id);
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      } finally {
        this.loading_module = false;
      }
    },

    async HandlerListLevels(module_id) {
      try {
        const request = {
          module_id: module_id,
        };
        const response = await this.$store.dispatch(
          "profile/LIST_LEVELS",
          request
        );

        this.levels = response.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      }
    },

    async HandlerListContent(module_id, level) {
      try {
        this.loadingContentData = true;
        const request = {
          module_id: module_id || this.module_id,
          level: level || this.level_id,
        };

        const response = await this.$store.dispatch(
          "profile/GET_FAVORITES",
          request
        );

        this.content_level = response.data.data;
      } catch (error) {
        console.log(error);
        if (error.response.status == 422) {
          let e = error.response.data.error;
          let showNotification = new Notification(e);
          showNotification.notification;
        }
        this.$snotify.error(error.response.data.message, "Error!");
      } finally {
        this.loadingContentData = false;
      }
    },

    HandlerCardListReponse() {
      this.HandlerListContent(this.module_id, this.level_id);
    },
  },
};
</script>

<style scoped>
@media (max-width: 1024px) {
  .classContainerBodySlot {
    width: 100% !important;
    padding: 1rem !important;
    margin-left: 0 !important;
  }
}
.capitalize {
  text-transform: capitalize;
}
.containerTabs {
  margin-top: 1rem;
  border-radius: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: #ffffff 0% 0% no-repeat padding-box;
}
/* .titleMyProfile{

} */
.btnSearch {
  text-align: center;
  font: normal normal normal 14px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  padding: 7px 36px;
}
.fisrtContainer_fisrtContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
}
.fisrtContainer_title {
  text-align: left;
  font: normal normal bold 18px/27px Poppins;
  letter-spacing: 0px;
  color: #101820;
}
.fisrtContainer {
  width: 100%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 12px;
  background-color: white;
  padding: 1rem;
}
</style>
